"use strict";

const imageSrc = asset => {
  return typeof asset === "string" ? asset : asset.src;
};
export { imageSrc };
//# sourceMappingURL=asset.mjs.map
